<!-- 商品客户端管理 -->
<template>
    <div>
        <Panel title="业务链查询">
            <template slot="buttons">
                <el-button class="blue" title="查询" plain icon="el-icon-fa-search" @click="pageTable.handleLoad()">查询</el-button>
                <el-button class="yellow" title="重置" plain icon="el-icon-fa-refresh" @click="pageTable.handleReset()">重置</el-button>
              <el-button  v-if="isOnlineSupport"  class="blue" title="业务同步" plain icon="el-icon-fa-retweet " @click="handleOnlineRefresh">业务同步</el-button>
            </template>
            <el-form>
                <el-row>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item label="业务链名称">
                            <el-input v-model="pageTable.param.biz_name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item label="业务链标识">
                            <el-input v-model="pageTable.param.biz_defn"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Panel>
        <Panel title="业务链列表">
            <template slot="buttons">
                <el-button class="green" title="新增" plain icon="el-icon-fa-plus" @click.stop="handlerAddChain">新增</el-button>
<!--                <el-button class="red" title="删除" plain icon="el-icon-fa-trash" @click="handlerDeleteMultiChain">删除</el-button>-->
            </template>
            <el-table highlight-current-row stripe border :data="pageTable.data" v-loading="pageTable.isLoading" ref="table"
                      @selection-change="handleSelectionChange" element-loading-spinner="el-icon-loading"
                      element-loading-text="数据加载中" height="calc(100vh - 620px)">
                 <el-table-column prop="$rownum" label="NO." width="50" align="center"/>
<!--                <el-table-column type="selection" align='center' width="50"></el-table-column>-->
                <el-table-column prop="bizname" label="业务名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="bizdefn" label="业务标识" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="bizdxpid" label="DXPID" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="biztype" label="业务类型" align="center" show-overflow-tooltip width="150"></el-table-column>
                <el-table-column label="维护类型" align="center" show-overflow-tooltip width="80">
                    <template slot-scope="{row}">
                        <span v-if="row.optype === '1'">系统维护</span>
                        <span v-if="row.optype === '2'">人工维护</span>
                    </template>
                </el-table-column>
                <el-table-column label="发送链编辑" align="center" width="100">
                    <template slot-scope="{row}">
                        <el-button v-if="row.optype === '2'" class="blue" title="编辑" plain @click="handlerEditSendChain(row.uuid,true)" icon="el-icon-fa-edit">编辑
                        </el-button>
                      <el-button v-if="row.optype === '1'" class="blue" title="查看" plain @click="handlerEditSendChain(row.uuid,false)" icon="el-icon-fa-eye">查看
                      </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="接收链编辑" align="center" width="100">
                    <template slot-scope="{row}">
                        <el-button v-if="row.optype === '2'" class="blue" title="编辑" plain @click="handlerEditReceChain(row.uuid,true)" icon="el-icon-fa-edit">编辑
                        </el-button>
                      <el-button v-if="row.optype === '1'" class="blue" title="查看" plain @click="handlerEditReceChain(row.uuid,false)" icon="el-icon-fa-eye">查看
                      </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="{row}">
                        <el-button v-if="row.optype === '2'" class="blue" title="编辑" plain @click="handlerEditChain(row.uuid)" icon="el-icon-fa-edit">编辑</el-button>
                        <el-button v-if="row.optype === '1'" class="blue" title="查看" plain @click="handlerViewChain(row.uuid)" icon="el-icon-fa-eye">查看</el-button>
                        <el-button v-if="row.optype === '2'" class="red" title="删除" plain @click="handlerDeleteChain(row.uuid)" icon="el-icon-fa-trash">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background :page-size.sync="pageTable.size" :current-page.sync="pageTable.curr" :total="pageTable.total"/>
        </Panel>

        <el-dialog close-on-press-escape append-to-body v-draggable title="业务链编辑" :visible.sync="chainEdit.visible" width="800px">
            <div class="dialog-button">
                <el-button class="blue" title="保存" @click="handlerSaveChain" icon="el-icon-fa-save" v-loading="chainEdit.loading"
                           v-if="!chainEdit.readonly">保存
                </el-button>
            </div>
            <div v-if="chainEdit.visible" v-loading="chainEdit.loading">
                <BizChainEditor v-model="chainEdit.data" :readonly="chainEdit.readonly" ref="BizChainEditorRef"></BizChainEditor>
            </div>
        </el-dialog>


        <el-dialog close-on-press-escape append-to-body v-draggable title="业务链组件编辑" :visible.sync="comEdit.visible" width="800px">
            <div v-if="comEdit.visible">
                <BizCom ref="BizComRef" v-model="comEdit.biz_uuid" :readonly="comEdit.readonly"></BizCom>
            </div>
        </el-dialog>


    </div>
</template>


<script>
import {PageTable} from 'cnetong-core-frontend';
import BizChainApi from "./BizChain";

import BizChainEditor from "./BizChainEditor.vue";
import BizCom from "./BizCom.vue";
import HeaderApi from "@/module/layout/header/Header";

const default_chain_data = {
    bizName: '',
    bizDefn: '',
    bizDesc: '',
    bizDxpid: '',
    bizType: '',
    bizCharset: '',
    bizSendUuid: '',
    bizReceUuid: ''
};

const default_com_data = {
    biz_uuid: '',
    cm_uuid: '',
    rc_order: 0
};
export default {
    components: {BizChainEditor, BizCom},
    data() {
        return {
            isOnlineSupport:false,
            pageTable: new PageTable({
                size: 10,
                doLoad: BizChainApi.listBizChain,
                autoLoad: true,
                params: {},
            }),
            chainSelection: [],
            // 业务链
            chainEdit: {
                visible: false,
                loading: false,
                readonly: false,
                data: Object.assign({}, default_chain_data),
                coms: []
            },
            // 业务链组件
            comEdit: {
                visible: false,
                loading: false,
                readonly: false,
                biz_uuid: "",
            },
        };
    },
    created: function () {
      HeaderApi.isOnlineSupport().then(resp=>{
        this.isOnlineSupport = resp.isOnlineSupport;
      })

    },
    methods: {
        // 查询业务链
        query() {
            this.pageTable.handleLoad();
        },
        // 新增业务链信息
        handlerAddChain() {
            this.chainEdit.data = Object.assign({}, default_chain_data);
            this.chainEdit.coms = [];
            this.chainEdit.readonly = false;
            this.chainEdit.visible = true;
        },
        // 保存业务连信息
        async handlerSaveChain() {
            await this.$refs.BizChainEditorRef.validate();
            await this.confirm();
            try {
                this.chainEdit.loading = true;
                let resp = await BizChainApi.saveBizChain(this.chainEdit.data);
                this.chainEdit.data.uuid = resp.uuid;
                this.query();
            } finally {
                this.chainEdit.loading = false;
            }
        },
        // 查看业务链信息
        async handlerViewChain(uuid) {
            await this.doLoadChain(uuid, true);
        },
        // 编辑业务链信息
        async handlerEditChain(uuid) {
            await this.doLoadChain(uuid, false);
        },
        // 执行查询业务链信息
        async doLoadChain(uuid, readonly) {
            this.chainEdit.readonly = readonly;
            try {
                this.chainEdit.data = Object.assign({}, default_chain_data);
                this.chainEdit.coms = [];
                this.chainEdit.loading = true;
                this.chainEdit.visible = true;
                let resp = await BizChainApi.getBizChain({uuid});
                this.chainEdit.data = resp.data;
            } finally {
                this.chainEdit.loading = false;
            }
        },
        // 删除业务链信息 连带删除业务链组件
        async handlerDeleteChain(uuid) {
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                await BizChainApi.deleteBizChain({ids: [uuid]});
                this.query();
            } finally {
                this.pageTable.isLoading = false;
            }
        },
        // 删除业务链信息 多个 连带删除业务链组件
        async handlerDeleteMultiChain() {
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                await BizChainApi.deleteBizChain({ids: this.chainSelection});
                this.query();
            } finally {
                this.pageTable.isLoading = false;
            }
        },

        // 编辑发送业务链组件
        async handlerEditSendChain(uuid,show) {
            await BizChainApi.getBizChain({uuid}).then(resp => {
                this.handlerShowCom(resp.data.bizSendUuid,show);
            });
        },
        // 编辑接收业务链组件
        async handlerEditReceChain(uuid,show) {
            await BizChainApi.getBizChain({uuid}).then(resp => {
                this.handlerShowCom(resp.data.bizReceUuid,show);
            });
        },
        // 显示业务组件编辑页面
        async handlerShowCom(biz_uuid,show) {
            try {
                this.comEdit.loading = true;
                this.comEdit.biz_uuid = biz_uuid;
                this.comEdit.visible = true;
                this.comEdit.readonly = show;
            } finally {
                this.comEdit.loading = false;
            }
        },
        // 多选
        handleSelectionChange(selection) {
            this.chainSelection = selection.map(v => v.uuid);
        },
      // 业务链同步
      async handleOnlineRefresh() {
        await HeaderApi.onlineRefresh();
        await this.pageTable.handleLoad();
        this.$message.success('在线同步已完成')
      },
    }
};
</script>
